module.exports = __webpack_public_path__ + "static/media/EG.5dbfa366.png";